import { GlobeHemisphereEastIcon } from '@phosphor-icons/react';

import { cn } from '@/lib/utils';

/**
 * Neutral identity for a workspace without an uploaded logo.
 *
 * Workspaces are account-like operating contexts, not file folders. A
 * hemisphere keeps the fallback neutral while making the shared account
 * context legible in the switcher, settings, and member-access surfaces.
 */
export function WorkspaceGlyph({ className }: { className?: string }): JSX.Element {
  return (
    <GlobeHemisphereEastIcon
      className={cn('size-3.5 shrink-0 text-muted-foreground', className)}
      weight="regular"
      aria-hidden="true"
    />
  );
}
